module.exports = __webpack_public_path__ + "view/img/guide2.e2731a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/guide2.png
// module id = gi4Y
// module chunks = 2